module.exports = __webpack_public_path__ + "img/рз_13.47099f99.png";